import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class RepAuxMoxService {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  getTipoCuenta(): Observable<any> {
    let url_ = this.dataUrl + '/repauxmov/get/tipo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getReporteAuxMov(fecha_ini: String, fecha_fin: String, movimiento: number, tipo_cuenta: number, cuenta_filtro: String, empresaId: String, limite: number) {
    let formData: any = new FormData();

    formData.append('fecha_ini', fecha_ini);
    formData.append('fecha_fin', fecha_fin);
    formData.append('movimiento', movimiento);
    formData.append('tipo_cuenta', tipo_cuenta);
    formData.append('cuenta_filtro', cuenta_filtro);
    formData.append('empresa_id', empresaId);
    formData.append('limit', limite);

    return this.http.post(this.dataUrl + '/repauxmov/post/reporteAux/', formData).pipe(
      catchError(e => {
        return throwError(e);
      })
    );
  }

  getPdf(fecha_ini: String, fecha_fin: String, movimiento: number, tipo_cuenta: number, cuenta_filtro: String, empresaId: String, empresa: String, limite: number) {
    let formData: any = new FormData();
    formData.append('fecha_ini', fecha_ini);
    formData.append('fecha_fin', fecha_fin);
    formData.append('movimiento', movimiento);
    formData.append('tipo_cuenta', tipo_cuenta);
    formData.append('cuenta_filtro', cuenta_filtro);
    formData.append('empresa_id', empresaId);
    formData.append('empresa', empresa);
    formData.append('limit', limite);

    return this.http.post(this.dataUrl + '/repauxmov/get/pdf/',formData, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getReporteTPdf(fecha_ini: String, fecha_fin: String, tipo_cuenta: number, empresaId: number) {

    return this.http.get(this.dataUrl + '/repauxmov/reporte_t/get/pdf/' + fecha_ini + '/' + fecha_fin + '/' + tipo_cuenta +  '/' + empresaId ,  {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }




  autocompletadoAuxiliarMovimientos(cuenta: String, gral_emp_id: number, fecha_inicial: String, fecha_final: String) :Observable<any> {

    return this.http.get(this.dataUrl + '/cta/aux/autocompletado/'+cuenta+'/'+gral_emp_id+'/'+fecha_inicial+'/'+fecha_final+'').pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}

export class CtbTipo {
  id?: number | undefined;
  titulo?: string | undefined;
}
